/* SessionListItem.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._42Yu6B7dHp%7Bz-index%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDyzSk%7Bborder-radius%3Avar(--ds-radius-xlarge%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbvLZJ%7Bdisplay%3Ablock%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r28HPE%7Bpadding-top%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCP8HPE%7Bpadding-inline-end%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGW8HPE%7Bpadding-bottom%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5E8HPE%7Bpadding-inline-start%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrulfZc%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzy7kJ%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2fwxA57p2s%7Btext-align%3Astart%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6d1Zr%3Ahover%7Bbackground-color%3Avar(--ds-surface-hovered%2C%23f0f1f2)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3gzVzLJNoT%3Aactive%7Bbackground-color%3Avar(--ds-surface-pressed%2C%23dddee1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrud1Zr%7Bbackground-color%3Avar(--ds-surface-hovered%2C%23f0f1f2)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruY9q9%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzjTy9%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1eOmH6sumd%3Ahover%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3gzVzLXsxn%3Aactive%7Bbackground-color%3Avar(--ds-background-selected-pressed%2C%238fb8f6)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrusumd%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdWVPG%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZB6UydnbC%7Binset-block-end%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcaykWR%7Btransform%3AtranslateY(100%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iC0zd8HPE%7Binset-inline-start%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1OKFqY8HPE%7Binset-inline-end%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pp6NdYbGa%7Bpointer-events%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3hhsrrNvrM%7Bborder-bottom-width%3Avar(--ds-border-width%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3BoeID6wH8%7Bborder-bottom-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3XVgLM9r67%7Bborder-bottom-color%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r2dnbC%7Bpadding-top%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZnuxbdnbC%7Bpadding-right%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGWdnbC%7Bpadding-bottom%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6QdnbC%7Bpadding-left%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2I62gzdnbC%7Binset-block-start%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iC0zddnbC%7Binset-inline-start%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VN91d%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrujOvk%7Bbackground-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2IhTon715P%7Btop%3A50%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02Z49V%7Bwidth%3A2rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VZ49V%7Bheight%3A2rem%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcakruI%7Btransform%3AtranslateY(-50%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1YKVNsdnbC%7Bopacity%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCPp0Oa%7Bpadding-inline-end%3Avar(--ds-space-600%2C3pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1YKVNs7dHp%7Bopacity%3A1%7D");
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { WidthObserver } from '@atlaskit/width-detector/width-observer';
import type { AgentSessionState } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { isLinkableSessionContext } from '../session-details/isLinkableSessionContext';
import { SessionAgent } from '../session-details/SessionAgent';
import { SessionContext, type SessionContextItem } from '../session-details/SessionContext';
import { SessionDetailsList } from '../session-details/SessionDetailsList';
import { SessionLastUpdated } from '../session-details/SessionLastUpdated';
import { SessionStatusIndicator } from '../session-details/SessionStatusIndicator';
import { SessionStatusInline } from '../session-details/SessionStatusInline';
import { SessionTitle } from '../session-details/SessionTitle';
import messages from './messages';
const COMPACT_WIDTH_BREAKPOINT = 480;
const styles = {
  item: "_1mT5xdRAKS",
  highlightedItem: "_42Yu6B7dHp",
  row: "_0bjKvDyzSk _3iDTPbvLZJ _39xV02N91d _24h04i2Njc _0Of8r28HPE _03SyCP8HPE _1wydGW8HPE _0LQT5E8HPE _0KLXrulfZc _1UtDYzy7kJ _2fwxA57p2s",
  interactiveRow: "_1eOmH6d1Zr _3gzVzLJNoT",
  hoveredRow: "_0KLXrud1Zr",
  selectedRow: "_0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd _3gzVzLXsxn",
  selectedHoveredRow: "_0KLXrusumd",
  divider: "_1mT5xdWVPG _1ZB6UydnbC _1VJPcaykWR _3iC0zd8HPE _1OKFqY8HPE _42Yu6B7dHp _1pp6NdYbGa _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67",
  content: "_4ouGXIdnbC",
  activationOverlay: "_0bjKvDyzSk _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _1mT5xdWVPG _2I62gzdnbC _3iC0zddnbC _39xV02N91d _0jFU0VN91d _0KLXrujOvk",
  contentAboveActivation: "_1pp6NdYbGa",
  trailing: "_3YEZNOdnbC",
  compactTrailing: "_1mT5xdWVPG _1OKFqY8HPE _2IhTon715P _39xV02Z49V _0jFU0VZ49V _37wbyuDIqT _1VJPcakruI",
  statusHidden: "_1YKVNsdnbC",
  withActions: "_03SyCPp0Oa",
  actions: "_1mT5xdWVPG _42Yu6B7dHp _1OKFqY8HPE _2IhTon715P _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Z49V _0jFU0VZ49V _1VJPcakruI",
  actionsHidden: "_1YKVNsdnbC _1pp6NdYbGa",
  actionsVisible: "_1YKVNs7dHp"
};

/**
 * Presentation data accepted directly from normalized agent sessions.
 * Deliberately independent of Relay records and fetching hooks.
 */
export type SessionListSession = Readonly<{
  id: string;
  conversationChannel?: Readonly<{
    id?: string;
    name?: string;
    readStatus?: boolean | null;
  }>;
  /** Presentation fallback for sessions that do not have a conversation channel. */
  title?: string;
  state?: AgentSessionState | (string & {});
  /** Raw identity data interpreted by SessionAgent. */
  displayAgent?: Readonly<{
    id: string;
    name: string;
    isRovo?: boolean;
    agentId?: string;
    agentIdentityAccountId?: string;
    agentNamedId?: string;
  }>;
  /** Associated context data, in display priority order. */
  contexts?: readonly SessionContextItem[];
  /** Time of the latest state change, in epoch milliseconds. */
  lastStateChangeAt?: number;
}>;
export type SessionListItemProps = Readonly<{
  /** Normalized data for the session represented by this row. */
  session: SessionListSession;
  /** Enables one whole-row activation target. The caller owns the resulting action. */
  onActivate?: React.MouseEventHandler<HTMLButtonElement>;
  /** Opens file and image contexts in a caller-owned preview. */
  onFilePreview?: (fileUrl: string, fileName: string) => void;
  /** Optional host-owned controls, rendered beside the row activation target. */
  actions?: React.ReactNode;
  /** Keeps the action trigger visible while its portaled menu is open. */
  isActionsOpen?: boolean;
  /** Whether the list should show a divider after this row. */
  hasDivider?: boolean;
  /** Whether this is the currently selected session. */
  isSelected?: boolean;
  testId?: string;
}>;
const getSessionListItemStatus = (session: SessionListItemProps['session']): React.ComponentProps<typeof SessionStatusIndicator>['status'] => {
  if (session.state === 'WORKING') {
    return 'working';
  }
  if (session.state === 'INPUT_REQUIRED' || session.state === 'AUTH_REQUIRED') {
    return 'needs-input';
  }
  if (session.conversationChannel?.readStatus === false) {
    return 'unread';
  }
  return undefined;
};

/** Responsive row presentation shared by SessionList and other session navigation surfaces. */
export const SessionListItem = ({
  session,
  onActivate,
  onFilePreview,
  actions,
  isActionsOpen = false,
  hasDivider,
  isSelected,
  testId
}: SessionListItemProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const [isCompact, setIsCompact] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hasFocusWithin, setHasFocusWithin] = useState(false);
  const handleWidthChange = useCallback((width: number) => {
    setIsCompact(width < COMPACT_WIDTH_BREAKPOINT);
  }, []);
  const title = (session.conversationChannel == null ? session.title?.trim() : session.conversationChannel.name?.trim()) || formatMessage(messages.sessionTitle);
  const status = getSessionListItemStatus(session);
  const hasStatus = status !== undefined;
  const hasActions = Boolean(actions);
  const areActionsVisible = isHovered || hasFocusWithin || isActionsOpen;
  const activationLabel = formatMessage(status === 'needs-input' ? messages.openSessionNeedsInputLabel : status === 'working' ? messages.openSessionWorkingLabel : messages.openSessionLabel, {
    title
  });
  const contexts = session.contexts?.filter(isLinkableSessionContext);
  const hasContextLink = Boolean(contexts?.length);
  const hasPersistentStatus = status === 'working' || status === 'needs-input';
  const displayAgent = session.displayAgent?.isRovo ? undefined : session.displayAgent;
  const hasMetadata = Boolean(isCompact && hasPersistentStatus || displayAgent || contexts?.length || session.lastStateChangeAt != null);
  const content = <Inline alignBlock="center" space="space.200" spread="space-between">
			<Stack grow="fill" space="space.050" xcss={styles.content}>
				<SessionTitle truncate>{title}</SessionTitle>
				{hasMetadata ? <SessionDetailsList testId={testId ? `${testId}-details` : undefined}>
						{hasPersistentStatus && isCompact ? <Inline as="span" alignBlock="center" space="space.050" shouldWrap={false}>
								{displayAgent ? <SessionAgent agents={[displayAgent]} showNames={false} iconSize={16} /> : null}
								<SessionStatusInline status={status === 'working' ? 'working' : 'needs-input'} showIcon={false} textSize="small" />
							</Inline> : displayAgent ? <SessionAgent agents={[displayAgent]} showNames iconSize={16} /> : null}
						{contexts?.length ? <SessionContext contexts={contexts} onFilePreview={onFilePreview} truncate /> : null}
						{session.lastStateChangeAt != null ? <SessionLastUpdated lastStateChangeAt={session.lastStateChangeAt} /> : null}
					</SessionDetailsList> : null}
			</Stack>
			{hasStatus ? <Inline as="span" alignBlock="center" space="space.150" xcss={cx(styles.trailing, hasActions && isCompact && styles.compactTrailing, hasActions && isCompact && areActionsVisible && styles.statusHidden)} testId={testId ? `${testId}-status` : undefined}>
					{hasPersistentStatus && !isCompact ? <SessionStatusInline status={status === 'working' ? 'working' : 'needs-input'} showIcon={false} textSize="small" /> : null}
					<SessionStatusIndicator status={status} decorative={hasPersistentStatus} testId={testId ? `${testId}-indicator` : undefined} />
				</Inline> : null}
		</Inline>;
  return <Box role="listitem" xcss={cx(styles.item, (isHovered || isSelected) && styles.highlightedItem)} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onFocusCapture={() => setHasFocusWithin(true)} onBlurCapture={(event: React.FocusEvent<HTMLDivElement>) => {
    if (!event.currentTarget.contains((event.relatedTarget as Node | null))) {
      setHasFocusWithin(false);
    }
  }}>
			<WidthObserver setWidth={handleWidthChange} />
			{hasDivider && !isHovered && !isSelected && <Box aria-hidden="true" xcss={styles.divider} />}
			{onActivate && hasContextLink ? <Box xcss={cx(styles.row, styles.interactiveRow, isSelected && styles.selectedRow, isHovered && !isSelected && styles.hoveredRow, isHovered && isSelected && styles.selectedHoveredRow, hasActions && styles.withActions)}>
					<Pressable xcss={styles.activationOverlay} onClick={onActivate} aria-label={activationLabel} aria-current={isSelected ? 'page' : undefined} testId={testId} />
					<Box xcss={styles.contentAboveActivation}>{content}</Box>
				</Box> : onActivate ? <Pressable xcss={cx(styles.row, styles.interactiveRow, isSelected && styles.selectedRow, isHovered && !isSelected && styles.hoveredRow, isHovered && isSelected && styles.selectedHoveredRow, hasActions && styles.withActions)} onClick={onActivate} aria-label={activationLabel} aria-current={isSelected ? 'page' : undefined} testId={testId}>
					{content}
				</Pressable> : <Box xcss={cx(styles.row, isSelected && styles.selectedRow, hasActions && styles.withActions)} testId={testId}>
					{content}
				</Box>}
			{actions && <Box xcss={cx(styles.actions, areActionsVisible ? styles.actionsVisible : styles.actionsHidden)} testId={testId ? `${testId}-actions` : undefined}>
					{actions}
				</Box>}
		</Box>;
};